import { parseJwt } from '@/utils/helpers'

export function generateCountdown(targetTime: number, applicationTime: number): number {
  const diffInSeconds = Math.floor((targetTime - applicationTime) / 1000)
  const diff = diffInSeconds > 0 ? diffInSeconds : 0
  console.log('generateCountdown | diff', diff)
  return diff
};

type AnyObject = { [key: string]: any }

export function flattenMaps(obj: AnyObject): AnyObject[] {
  function deepestMaps(o: AnyObject, acc: AnyObject[]): AnyObject[] {
    for (const [_, value] of Object.entries(o)) {
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const hasNestedObjects = Object.values(value).some(v => typeof v === 'object' && v !== null && !Array.isArray(v))
        if (hasNestedObjects) {
          deepestMaps(value, acc)
        }
        // Remove nested maps and retain only simple properties
        const simpleProps: AnyObject = Object.entries(value).reduce((acc: AnyObject, [k, v]) => {
          if (typeof v !== 'object' || v === null || Array.isArray(v)) {
            acc[k] = v
          }
          return acc
        }, {})
        if (Object.keys(simpleProps).length > 0) {
          acc.push(simpleProps)
        }
      }
    }
    return acc
  }

  return deepestMaps(obj, [])
}

export function checkFeatureEnabled(features: string[], promoterAccountFeatures: PromoterAccountFeaturesPc2[]): boolean {
  for (const feature of features) {
    if (!promoterAccountFeatures || !Array.isArray(promoterAccountFeatures)) return false
    // Find the corresponding feature in the promoterAccountFeatures array
    const matchingFeature = promoterAccountFeatures.find(promoterFeature => promoterFeature.id === feature)

    // If the feature is not found or it is not enabled, return false immediately
    if (!matchingFeature?.enabled) {
      return false
    }
  }

  return true
}

// All permissionKeys listed should be all inside promoterPermissions for this to be true
export function checkPermissionEnabled(permissionKeys: string[], promoterPermissions: PermissionsState) {
  if (!promoterPermissions) {
    return false
  }

  const promoterPermissionsKeys = Object.keys(promoterPermissions)

  if (promoterPermissionsKeys.length <= 0) {
    return false
  }

  return permissionKeys.every(permissionKey =>
    promoterPermissionsKeys.some(promoterPermissionKey =>
      promoterPermissions[promoterPermissionKey]?.includes(permissionKey) || false,
    ),
  )
}

export function checkIsAdminAccount(xAuthToken: string) {
  const jwt = parseJwt(xAuthToken)
  const clientIdentity = JSON.parse(jwt['client-identity'])
  return clientIdentity.accountType === 'ADMIN'
}

// The gating decision for fetching the promoter's region settings, pulled out
// of the auth middleware so it can be unit-tested — `client/middleware/**` is
// excluded from vitest.
//
// `shouldDispatch`: only when an account is present and the settings have not
// already been fetched this session. The fetch latches on success (including
// the null answer most promoters get), so this is false thereafter.
//
// `shouldAwait`: only on a cold load. That path is already blocked on
// VERIFY_TOKEN, and waiting for the settings there renders the right currency
// symbol on first paint instead of flashing '$' and correcting. In-SPA
// navigation stays fire-and-forget so nothing is held up.
export function planRegionSettingsFetch({ promoterOid, hasFetched, isColdLoad }: {
  promoterOid: number | null
  hasFetched: boolean
  isColdLoad: boolean
}): { shouldDispatch: boolean, shouldAwait: boolean } {
  const shouldDispatch = promoterOid !== null && !hasFetched
  return {
    shouldDispatch,
    shouldAwait: shouldDispatch && isColdLoad,
  }
}
